import { render, staticRenderFns } from "./ListAccomodation.vue?vue&type=template&id=57b007ec&scoped=true"
import script from "./ListAccomodation.vue?vue&type=script&lang=js"
export * from "./ListAccomodation.vue?vue&type=script&lang=js"
import style0 from "./ListAccomodation.vue?vue&type=style&index=0&id=57b007ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b007ec",
  null
  
)

export default component.exports